<!--首页-->
<template>
  <div class="loginBody" v-bind:style="loginHeight" :style="getLoginBg">
    <!--定位-->
    <PositioningAddress></PositioningAddress>
    <div class="videoBg" v-if="loginVideoUrl != undefined && loginVideoUrl.length > 0">
      <!-- 如果添不加 muted 静音，有时候不能自动播放，是chrome的限制 -->
      <video autoplay="true" loop="true" muted class="videoPlayer">
        <source :src="loginVideoUrl" type="audio/mp4" />
        您的浏览器不支持 Video 标签
      </video>
    </div>
    <div class="unitTitle">
      <div>
        <!--客户特殊需求：登陆页 展示logo和字体变更-->
        <img v-show="logImg != ''" :src="logImg" class="logo" alt="" />
        <p class="cnTitle" v-if="companyTitle != ''" :style="{ 'font-size': 36 + 'px', 'line-height': 40 + 'px' }"
          style="font-family: 宋体">
          {{ companyTitle }}
        </p>

        <!--常规登陆页-->
        <p class="cnTitle" v-else :style="{ 
            'font-size': 36 - index * 4 + 'px',
            'line-height': 40 - index * 4 + 'px',
          }" v-for="(item, index) in titles">
          电力需求侧管理平台
        </p>
      </div>
      <div class="qrcodediv" v-show="qrCodeShow">
        <!-- 底部app扫码用的二维码，每个单位可能不一样 -->
        <div class="qrcode">
          <div id="urlCode" style="width: 100px; height: 100px"></div>
          <p>{{ qrCodeList.name }}</p>
        </div>

      </div>
    </div>

    <div v-show="copyRightIsDisplay" class="information flexCenterColumn">
      <a :href="copyRightUrl" target="_Blank">{{ copyRight.rightinfo }}</a>
      <a :href="copyRightUrl" target="_Blank">{{ copyRight.rightNumber }}</a>
    </div>
    <div class="loginContent">
      <p class="loginTitle">用户登录</p>
      <p class="loginTitle" style="font-size: 18px; line-height: 20px">
        USER&nbsp;&nbsp;&nbsp;&nbsp;LOGIN
      </p>
      <!-- ./ -->
      <div class="loginText flexStart" v-show="!showChangPW">
        <img src="../../public/static/image/科技蓝/login/username.png" /><input type="text" name="userCode"
          v-model="userCode" placeholder="用户名" @keyup.enter="loginButton" autofocus @blur="checkUser" />
      </div>
      <div class="loginText flexStart" v-show="!showChangPW">
        <img src="../../public/static/image/科技蓝/login/password.png" /><input type="password" name="password"
          v-model="password" placeholder="密码" @keyup.enter="loginButton" />
      </div>
      <div class="loginText flexStart" v-show="verificationCode && !showChangPW">
        <img src="../../public/static/image/科技蓝/login/code.png" /><input type="text" v-model="seccode" placeholder="验证码"
          @keyup.enter="loginButton" style="width: 150px" />
        <valid-code ref="validCode"></valid-code>
      </div>
      <!-- 修改密码-->
      <div class="loginText flexStart" v-show="showChangPW">
        <img :src="getResourcesByName('login/password.png')" /><input type="password" name="newPassword"
          v-model="newPassword" placeholder="输入新密码" @blur.prevent="regPW" />
      </div>
      <div class="loginText flexStart" v-show="showChangPW">
        <img :src="getResourcesByName('login/password.png')" /><input type="password" name="checkPassword"
          v-model="checkPassword" placeholder="确认新密码" />
      </div>
      <span id="loginSpan" class="loginButton nomalButton" @click="loginButton" v-show="!showChangPW">登 录</span>
      <span class="loginButton nomalButton" @click="submitButton" v-show="showChangPW">提交修改</span>
      <span class="errorMsg" v-if="errorMsg != ''"><img :src="getResourcesByName('login/error.png')" />&nbsp;&nbsp;{{
        errorMsg
        }}</span>
    </div>
  </div>
</template>

<script type="text/javascript">
  import PositioningAddress from "@/components/module/map/PositioningAddress.vue";
  import validCode from "@/components/module/code/validCode.vue";
  import {getReadDeviceTree} from "../api/abbNewApi";
  export default {
    components: {
      validCode,
      PositioningAddress,
    },
    props: [],
    data () {
      return {
        showChangPW: false,
        userCode: "",
        password: "",
        newPassword: "",
        checkPassword: "",
        seccode: "",
        codelist: "",
        errorMsg: "",
        copyRightIsDisplay: true, //是否展示copyright
        qrCodeList: {
          name: "",
          url: "",
        },
        logImg: "",
        companyTitle: "", //TITLE
        loginVideoUrl: undefined,
        loginImgBgUrl: undefined,
        copyRight: {
          rightinfo: "",
          rightNumber: "",
        },
        copyRightUrl: undefined,
        verificationCode: false, //配置验证码显示隐藏
        qrCodeShow: false,
        isStrongPassword: 0,
      };
    },
    created () {
      debugPage=this;
      //初始化配置
      this.$store.menuStore.state.menuType=1;
      if(
        DWSystemSetting!=undefined&&
        DWSystemSetting.verificationCode!=undefined
      ) {
        this.verificationCode=DWSystemSetting.verificationCode;
        this.qrCodeShow=DWSystemSetting.qrCodeShow;
      }

      if(
        DWSystemSetting.logDingZhi!=undefined&&
        DWSystemSetting.companyName!=undefined&&
        !isempty(DWSystemSetting.logDingZhi[DWSystemSetting.companyName])
      ) {
        //debugger
        if(!isempty(DWSystemSetting.logDingZhi[DWSystemSetting.companyName])) {
          this.logImg=DWSystemSetting.logDingZhi[DWSystemSetting.companyName];
        }
      } else {
        this.logImg="";
      }

      if(DWSystemSetting.companyTitle!=undefined) {
        this.companyTitle=DWSystemSetting.companyTitle;
      } else {
        this.companyTitle="";
      }

      if(DWSystemSetting.copyRightIsDisplay!=undefined) {
        this.copyRightIsDisplay=DWSystemSetting.copyRightIsDisplay;
      } else {
        this.copyRightIsDisplay=true;
      }
      //是否需要强验证
      if(DWSystemSetting.isStrongPassword!=undefined) {
        this.isStrongPassword=DWSystemSetting.isStrongPassword;
      }
    },
    mounted () {
      console.log(JSON.stringify(this.$store.resourcesStore.state));

      var num=0;
      var d=setInterval((v) => {
        this.userCode=this.getQueryVariable("userCode");
        // this.password = this.getQueryVariable("userCode");
        num++;
        if(this.userCode||num>2) {
          clearInterval(d);
        }
        if(this.userCode) {
          this.userCode=this.getQueryVariable("userCode")||"";
          this.password=this.getQueryVariable("userCode")||"";
          // this.password = 3
          this.loginButton();
        }
      },900);
      this.code();
      //设置二维码列表
      this.qrCodeList=DWSystemSetting.qrCodeList;
      //为二维码增加参数·避免缓存
      for(var i=0,len=this.qrCodeList.length;i<len;i++) {
        var item=this.qrCodeList[i];
        item.url=item.url+"?version="+new Date().formatByDate();
      }
      //设置视频背景
      this.loginVideoUrl=DWSystemSetting.loginVideoUrl;
      //设置图片背景
      this.loginImgBgUrl=DWSystemSetting.loginImgBgUrl;
      if(!isempty(this.loginImgBgUrl)) {
        //每天刷新缓存
        this.loginImgBgUrl=
          this.loginImgBgUrl+"?version="+new Date().formatByDate();
      }
      //设置版权声明
      this.copyRight=DWSystemSetting.copyRight;
      this.copyRightUrl=DWSystemSetting.copyRightUrl;
      //后台连接的二维码
      var qrcode=new QRCode(document.getElementById("urlCode"),{
        width: 100,
        height: 100,
      });
      qrcode.makeCode(DWSystemSetting.qrCodeList.url);
      /*下载的二维码*/
      /*new QRCode(document.getElementById("urlCode"),{width: 100,height: 100}).makeCode(DWSystemSetting.qrCodeList.url)*/
    },
    destroyed () {},
    computed: {
      titles () {
        if(this.webConfig==undefined||this.webConfig.Title==undefined) {
          return [""];
        }
        var list=this.webConfig.Title.split(";");
        document.title=list[0];
        return list;
      },
      loginHeight () {
        return {
          height: ""+this.height/100+"rem",
        };
      },
      webConfig () {
        return this.$store.cacheStore.getters.getWebConfig;
      },

      getBackgroudImageStyle () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle;
      },
      getColorStyleById () {
        return this.$store.resourcesStore.getters.getColorStyleById;
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName;
      },
      getClassName () {
        return this.$store.resourcesStore.getters.getClassName;
      },
      getLoginBg () {
        return !isempty(this.loginVideoUrl)
          ? {}
          :{
            "background-image": "url("+this.loginImgBgUrl+")",
            "background-size": "100% 100%",
            "background-repeat": "no-repeat",
            "height": "100% !important",
          };
      },
    },
    watch: {
      userCode (nv,ov) {
        this.errorMsg="";
      },
      password (nv,ov) {
        this.errorMsg="";
      },
    },
    methods: {
      getQueryVariable (variable) {
        if(window.location.href.indexOf("?")==-1) {
          $(".loginBody").css("opacity",1);
          return;
        }
        var query=window.location.href.split("?")[1];

        var vars=query.split("&");
        for(var i=0;i<vars.length;i++) {
          var pair=vars[i].split("=");
          if(pair[0]==variable) {
            return pair[1];
          }
        }
        return false;
      },
      checkUser () {
        if(this.isStrongPassword==0) {
          return;
        }
        this.$api.userApi.checkUser(
          this.userCode,
          (respon) => {
            $("#loginSpan").css("pointer-events","auto");
            $("#loginSpan").css("background","#308ff7");
          },
          (respon) => {
            this.$dialogMethod.showMessage(respon);
            $("#loginSpan").css("background","#ccc");
            $("#loginSpan").css("pointer-events","none");
          }
        );
      },
      submitButton () {
        this.regPW();
        if(this.newPassword==this.checkPassword) {
        } else {
          this.$dialogMethod.showMessage("输入密码不一致！");
        }
      },
      regPW () {
        if(this.newPassword.length<8||this.newPassword.length>16) {
          this.$dialogMethod.showMessage("密码长度不符合，密码长度：8-16！");
          return;
        }
        var rgx=/^[0-9a-zA-Z\x21-\x7e]{8,16}$/;
        if(!rgx.test(this.newPassword)) {
          this.$dialogMethod.showMessage("密码只能包含数字，字母和字符！");
          return;
        }
        var iNum=0,
          iLtt=0,
          iSym=0;
        var num=this.newPassword.match(/\d{1}/g);

        if(num!=null) {
          for(let i=0;i<num.length;i++) {
            iNum++;
          }
        }

        var ltt=this.newPassword.match(/[a-zA-Z]/g);

        if(ltt!=null) {
          for(let i=0;i<ltt.length;i++) {
            iLtt++;
          }
        }

        var sym=this.newPassword.match(/((?=[\x21-\x7e]+)[^A-Za-z0-9])/g);

        if(sym!=null) {
          for(let i=0;i<sym.length;i++) {
            iSym++;
          }
        }

        if(iLtt==0&&iSym==0) {
          this.$dialogMethod.showMessage("纯数字密码，请加入字符和字母！");
          return;
        }
        if(iNum==0&&iLtt==0) {
          this.$dialogMethod.showMessage("纯符号密码，请加入数字和字母！");
          return;
        }
        if(iNum==0&&iSym==0) {
          this.$dialogMethod.showMessage("纯字母密码，请加入字符和数字！");
          return;
        }
        if(iLtt==0) {
          this.$dialogMethod.showMessage("数字和符号构成的密码，请加入字母！");
          return;
        }
        if(iSym==0) {
          this.$dialogMethod.showMessage("数字和字母构成的密码，请加入字符！");
          return;
        }
        if(iNum==0) {
          this.$dialogMethod.showMessage("字母和符号构成的密码，请加入数字！");
          return;
        }
      },
      code () {
        this.codelist="";
        var codes=this.$refs.validCode.codeList;
        for(let i=0;i<codes.length;i++) {
          this.codelist=this.codelist+codes[i].code;
        }
      },
      generateCode (id) {
        /*生成二维码*/
        new QRCode(document.getElementById(id),"http://www.runoob.com");
      },
      // 登陆
      loginButton () {
        localStorage.setItem("themeName",'科技蓝');
        this.$store.menuStore.commit("getMenuList");
        return
        // console.log("点击登录",this.userCode);
        // console.log("点击登录密码",this.password);
        if(this.verificationCode) {
          if(this.seccode.toUpperCase()!=this.codelist.toUpperCase()) {
            this.$dialogMethod.showMessage("验证码错误");
            this.$refs.validCode.refreshCode();
            this.code();
            return false;
          }
        }

        //登录
        var captcha=this.seccode==""? "web:"+1234:"web:"+this.seccode;
        this.$api.userApi.login(
          this.userCode,
          hex_md5(this.password),
          "Web",
          captcha,
          this.isStrongPassword,
          (respon) => {
            //判断是否有修改过密码 判断是否为强验证
            if(respon.changePassword==0&&this.isStrongPassword==1) {
              //if(this.isStrongPassword == 1) {
              document.getElementsByClassName("loginTitle")[0].innerHTML=
                "修改密码";
              document.getElementsByClassName("loginTitle")[1].innerHTML=
                "首次登录请修改密码，包含数字，字母和字符";
              this.showChangPW=true;
              return;
            }

            //获取用户信息
            localStorage.setItem("nowWedoSystemUserCode",this.userCode);
            this.$store.userStore.commit("setNowUserCode",this.userCode);
            //用户的具体信息

            //获取用户单位信息
            this.$store.unitStore.commit("getUnitTree");
            getReadDeviceTree({'appType': "",'appTypeNos': ''}).then(data => {
              localStorage.setItem('treeList',JSON.stringify(data.data));
            })


            //this.$dialogMethod.showMessage("登录成功，正在跳转。。。");
            setTimeout(() => {
              //获取菜单并且进入主界面
              this.$store.menuStore.commit("getMenuList");
              this.$store.deviceStore.commit("getReadDeviceTreeWithTypeNos",36)
              //this.$store.deviceStore.commit("getReadDeviceTreeWithTypeNos", 237)
              //获取电表、水表
              this.$store.deviceStore.commit("getDeviceTreeByappTypeNos",1001);
              this.$store.deviceStore.commit("getDeviceTreeByappTypeNos",237);
              this.$message({message: '登陆成功，正在跳转...',type: 'success'});
            },1000);
            sessionStorage.setItem("isLogin",Date.now());
            //连接新后台
            this.$wedoWebSocketClient.connect(respon.webSocketUrl,respon.pkid);
          },
          (respon) => {
            this.$dialogMethod.showMessage(respon);
            //this.errorMsg = respon
          }
        );
      },
    },
  };
</script>

<style scoped>
  .loginButton {
    background: #308ff7;
    color: white;
    border-color: #308ff7;

  }

  .loginContent input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    height: 27px !important;
    line-height: 27px !important;
    border-radius: 0 4px 4px 0;
  }

  .unitTitle {
    margin-top: 5%;
    margin-left: 5%;
    margin-bottom: 3%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* min-width: 500px; */
    /* position: absolute; */
    z-index: 1;
  }

  .errorMsg {
    display: flex;
    align-items: center;
    width: 89%;
    margin-left: 5px;
    margin-top: 15px;
  }

  .loginText {
    margin-top: 20px;
    border: 1px solid #d6d6d6;
    padding: 2%;
    width: 85%;
    border-radius: 5px;
  }

  .loginText img {
    width: 20px;
    height: 20px;
  }

  .loginText input {
    outline: none;
    width: calc(100% - 25px);
    height: 27px !important;
    line-height: 27px !important;
    font-size: 16px;
    margin-left: 5px;
  }

  .loginButton {
    cursor: pointer;
    margin-top: 20px;
    font-size: 20px;
    width: 89%;
    height: 40px;
    line-height: 40px;
  }

  .loginTitle {
    width: 89%;
    font-size: 30px;
    line-height: 35px;
    margin-bottom: 0;
  }

  .cnTitle {
    letter-spacing: 13px;
    margin-bottom: 10px;
  }

  .loginBody {
    min-width: 1366px;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex !important;
    justify-content: space-between !important;
    opacity: 0;
  }

  .loginContent {
    width: 350px;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    /* position: absolute;
		 top: 12%; 
		 right: 20px;*/
    padding: 30px;
    border-radius: 10px;
    z-index: 99;
    height: 335px;
    position: absolute;
    top: calc(0.5 * (100% - 410px));
    left: calc(0.5 * (100% - 395px));
  }

  .videoBg {
    background: white;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    overflow: hidden;
  }

  .videoPlayer {
    width: 100%;
  }

  .qrcode {
    display: inline-flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-right: 40px;
  }

  .qrcode>img {
    width: 100px;
    height: 100px;
  }

  .qrcode>p {
    color: white;
    text-align: center;
  }

  .information {
    position: absolute;
    z-index: 1;
    bottom: 20px;
    width: 100%;
  }

  .information>a {
    display: block;
    color: #bbb;
    font-size: 14px;
    text-align: center;
    text-decoration: none;
  }

  .logo {}
</style>